<template>
  <div
    class="sidebar-wrapper"
  >
    <b-nav vertical class="active">
      <template v-for="(item, index) in navItems.items">
        <div
          class="item-wrapper"
          v-if="canAccessPage(item) && hasPermission(item) && !item.hidden"
          :key="index"
        >
          <div v-if="item.line" class="bottomLine"></div>
          <div v-if="item.overview" class="overview">{{ item.overview }}</div>
          <template>
            <SidebarNavIcons
              :icon="item.icon"
              v-if="item.children"
              v-b-toggle="item.collapse_id"
              :name="item.name"
              :url="item.url"
              :expandIcon="item.expandIcon"
            ></SidebarNavIcons>
            <SidebarNavIcons
              :icon="item.icon"
              v-else
              :name="item.name"
              :url="item.url"
            ></SidebarNavIcons>
          </template>
          <b-collapse
            v-if="item.children && item.expandIcon"
            :id="item.collapse_id"
            accordion="my-accordion"
          >
            <ul class="children-nav">
              <template v-for="(children, subIndex) in item.children">
                <li
                  v-if="!children.hidden && canAccessPage(children) && hasPermission(children)"
                  class="active"
                  :key="subIndex"
                >
                  <template>
                    <SidebarNavIcons
                      :icon="item.icon"
                      :name="children.name"
                      :url="children.url"
                    ></SidebarNavIcons>
                  </template>
                </li>
              </template>
            </ul>
          </b-collapse>
        </div>
      </template>
    </b-nav>
  </div>
</template>

<script>
import SidebarNavIcons from "../SidebarNavIcons";
import consts from "@/_consts";
// next: do incentive events

export default {
  components: {
    SidebarNavIcons
  },
  props: {
    navItems: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      userPermissionsData: null
    };
  },
  mounted() {
    this.loadUserPermissionsData();
  },
  watch: {
    '$route'() {
      this.loadUserPermissionsData();
    }
  },
  methods: {
    loadUserPermissionsData() {
      const permission = sessionStorage.getItem(consts.LOCAL_STORE.permission);
      this.userPermissionsData = permission ? JSON.parse(permission) : null;
    },
    hasPermission(item) {
      if (item.permissionName && item.permissionName.length) {
        return this.userPermissionsData && this.userPermissionsData.some(i => i.name === item.permissionName);
      }
      // If there is no permissionName declared on the nav item, always show that item
      return true;
    },
    canAccessPage(item) {
      if (item.entity && item.entity.length) {
        return !!item.entity.filter(
          e =>
            e === "all" ||
            this.$can(this.$perName.READ, e) ||
            this.$can("get_employer_sftp", e) ||
            this.$can("policy_manage", e)
        ).length;
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/core-variables";
.admin-sidebar {
  .nav-link {
    cursor: pointer;
  }

  .sidebar {
    background: none;
    font-size: 0.75rem;
    .sidebar-header {
      text-align: center;
      padding-top: 0.625rem;
      padding-bottom: 1rem;
      color: $light-grey;
    }
    .sidebar-nav {
      background: $aduro-primary-color;
      height: 100%;
    }
    .circle {
      box-sizing: border-box;
      height: 64.98px;
      width: 64.98px;
      border: 1px solid $light-grey;
      background-color: $grey-4;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-border-radius: 50%;
      margin: 0 auto;
    }
  }

  ul.nav li.nav-item {
    ul.children-nav {
      margin-left: 0;
      padding-left: 0;
      list-style: none;
      .nav-link {
        text-align: right;
      }
    }
  }

  .sidebar-nav {
    overflow-x: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar-track {
      background-color: lighten($grey-5, 5%);
      border-right: 1px solid darken($grey-5, 5%);
      border-left: 1px solid darken($grey-5, 5%);
    }

    &::-webkit-scrollbar-thumb {
      height: 50px;
      background-color: darken($grey-5, 10%);
      background-clip: content-box;
      border-color: transparent;
      border-style: solid;
      border-width: 1px 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Sidebar.vue